import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HomeTR from "../pages/home-tr/page";
import ServicesIndexPage from "../pages/services/ServicesIndexPage";
import ServicePage from "../pages/services/ServicePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/tr",
    element: <HomeTR />,
  },
  // EN Services
  {
    path: "/services",
    element: <ServicesIndexPage lang="en" />,
  },
  {
    path: "/services/:slug",
    element: <ServicePage lang="en" />,
  },
  // TR Services
  {
    path: "/tr/hizmetler",
    element: <ServicesIndexPage lang="tr" />,
  },
  {
    path: "/tr/hizmetler/:slug",
    element: <ServicePage lang="tr" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
